import { Fragment, useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getDomEnvio, getEstado, getProvincia, setDireccion } from '../../actions/domiciliosEnvio'
import { getEstados } from '../../actions/estados'
import {
  setCodPostalDomEnvioMod,
  setDireccionDomEnvioMod,
  setEstadoDomEnvioMod,
  setLocalidadDomEnvioMod,
  setNombreDomEnvioMod,
  setProvinciaDomEnvioMod,
} from '../../actions/pedidos'
import { getProvincias } from '../../actions/provincias'
import i18n from '../../lang/idiomas'

const DomiciliosEnvio = props => {
  const dispatch = useDispatch()

  const domicilios_envio = useSelector(state => state.domiciliosEnvio.domicilios_envio)
  const domicilio = useSelector(state => state.domiciliosEnvio.domicilio)
  const estado = useSelector(state => state.domiciliosEnvio.estado)
  const provincia = useSelector(state => state.domiciliosEnvio.provincia)
  const pedido_cargando = useSelector(state => state.pedidos.isLoading)
  const provincias = useSelector(state => state.provincias.provincias)
  const estados = useSelector(state => state.estados.estados)
  const pedido = useSelector(state => state.pedidos.pedido)
  const [prevOrder, setPrevOrder] = useState({})
  const provinciasBloqueadas = ['51', '52', '38', '35']

  const [state, setState] = useState({
    domicilio: '',
    estado: '',
    provincia: '',
  })
  const [isCustomAddress, setIsCustomAddress] = useState(false)

  const customAddressButtonProps = useMemo(() => {
    return {
      className: !isCustomAddress ? 'btn btn-primary' : 'btn btn-danger',
      text: !isCustomAddress ? `${i18n.t('domicilios.nuedomen')}` : `${i18n.t('general.cancelar')}`,
    }
  }, [isCustomAddress])
  const isAddressSelected = useMemo(() => {
    return domicilio && domicilio.id
  }, [domicilio])
  const [previousState, setPreviousState] = useState({})
  const previousProvinceLocked = useMemo(() => {
    if (previousState?.estado !== 'ES') return true
    if (!previousState?.provincia) return false
    return provinciasBloqueadas.includes(previousState?.provincia)
  }, [previousState?.provincia])
  const editableFields = useMemo(
    () => props.editable && isCustomAddress,
    [isCustomAddress, props.editable],
  )

  useEffect(() => {
    dispatch(getDomEnvio())
    if (props.editable && estados.length === 0) {
      dispatch(getEstados())
    }
  }, [])

  useEffect(() => {
    if (!pedido_cargando) {
      if (domicilios_envio?.length === 1) {
        setState({ ...state, domicilio: domicilios_envio[0] })
        dispatch(getEstado(domicilios_envio[0].estado))
        dispatch(getProvincias(domicilios_envio[0].estado))
        if (pedido.provincia_dom_envio) {
          dispatch(getProvincia(domicilios_envio[0].estado, pedido.provincia_dom_envio))
        } else {
          dispatch(getProvincia(domicilios_envio[0].estado, domicilios_envio[0].provincia))
        }

        dispatch(setDireccion(domicilios_envio[0]))
      }

      if (
        domicilios_envio?.length > 1 &&
        (pedido.domicilio_envio || pedido.domicilio_envio === 0) &&
        domicilio?.numero_direccion !== pedido.domicilio_envio
      ) {
        const dom_env = domicilios_envio.filter(
          domicilio => domicilio.numero_direccion === parseInt(pedido.domicilio_envio),
        )

        if (dom_env && dom_env.constructor === Array && dom_env.length > 0) {
          dispatch(getEstado(dom_env[0].estado))
          dispatch(getProvincias(dom_env[0].estado))
          dispatch(getProvincia(dom_env[0].estado, dom_env[0].provincia))
          dispatch(setDireccion(dom_env[0]))
        }
      }
    }
  }, [pedido_cargando, domicilios_envio])

  const createCustomAddress = () => {
    if (isCustomAddress) {
      dispatch(setDireccion(domicilios_envio[0]))
      dispatch(setNombreDomEnvioMod(prevOrder?.nombre_dom_envio))
      dispatch(setDireccionDomEnvioMod(prevOrder?.direccion_dom_envio))
      dispatch(setLocalidadDomEnvioMod(prevOrder?.localidad_dom_envio))
      dispatch(setEstadoDomEnvioMod(prevOrder?.estado_dom_envio))
      dispatch(setProvinciaDomEnvioMod(prevOrder?.provincia_dom_envio))
      dispatch(setCodPostalDomEnvioMod(prevOrder?.cod_postal_dom_envio))
      setIsCustomAddress(false)
      return
    }
    setPrevOrder(pedido)
    const provincia = pedido.provincia_dom_envio
      ? pedido.provincia_dom_envio
      : domicilio?.estado === 'ES'
      ? provinciasBloqueadas.includes(domicilio.province)
        ? domicilio.provincia
        : null
      : domicilio.provincia
    let estado = domicilio?.estado ?? null
    const previousValues = { estado, provincia }
    dispatch(setEstadoDomEnvioMod(previousValues.estado))
    dispatch(setProvinciaDomEnvioMod(provincia))
    setPreviousState(previousValues)
    // dispatch(setDireccion({}))
    setIsCustomAddress(true)
  }

  const onChange = e => {
    e.preventDefault()
    if (e.target.name === 'domicilio' && e.target.value !== '') {
      const direccion = domicilios_envio.filter(dom => dom.id === parseInt(e.target.value))
      setIsCustomAddress(false)
      setPreviousState({})

      setState({ ...state, domicilio: direccion[0] })

      dispatch(getEstado(direccion[0].estado))
      dispatch(getProvincias(direccion[0].estado))
      dispatch(getProvincia(direccion[0].estado, direccion[0].provincia))
      dispatch(setDireccion(direccion[0]))
      dispatch(setNombreDomEnvioMod(null))
      dispatch(setDireccionDomEnvioMod(null))
      dispatch(setLocalidadDomEnvioMod(null))
      dispatch(setEstadoDomEnvioMod(null))
      dispatch(setProvinciaDomEnvioMod(null))
      dispatch(setCodPostalDomEnvioMod(null))
    } else {
      if (e.target.name === 'estado') {
        dispatch(getProvincias(e.target.value))
        dispatch(setEstadoDomEnvioMod(e.target.value))
      } else if (e.target.name === 'provincia') {
        console.log(e.target.readOnly)
        dispatch(setProvinciaDomEnvioMod(e.target.value))
      } else {
        setState({
          ...state,
          [e.target.name]: e.target.value,
        })
      }
    }
  }

  const handleFocus = e => {
    e.target.select()
  }

  return (
    <div className='tt-shopcart-box domicilio-envio-box'>
      <Fragment>
        <h4 className='tt-title'>{i18n.t('domicilios.direnvio')}</h4>
        <div className='address-title'>
          <p>{i18n.t('domicilios.seldiren')}</p>
          {props?.editable && !props?.pedidoGuardado && isAddressSelected ? (
            <button
              onClick={createCustomAddress}
              type='button'
              className={customAddressButtonProps.className}>
              {customAddressButtonProps.text}
            </button>
          ) : (
            ''
          )}
        </div>
        <form className='form-default'>
          <div className='row'>
            <div className=' col-sm-12 col-md-12 col-lg-12'>
              <div className='form-group '>
                <label htmlFor='input_domicilio'>
                  {i18n.t('domicilios.domicil')} <sup>*</sup>
                </label>
                <select
                  className='form-control'
                  id='input_domicilio'
                  name='domicilio'
                  onChange={onChange}
                  disabled={!!(pedido_cargando || props.pedidoGuardado)}
                  value={domicilio.id || ''}>
                  <option
                    key='0'
                    value=''
                    disabled>
                    {i18n.t('domicilios.seldoenv')}
                  </option>
                  {domicilios_envio.map(dom => {
                    return (
                      <option
                        key={dom.id}
                        value={dom.id}>
                        {dom.nombre}
                      </option>
                    )
                  })}
                </select>
              </div>
            </div>
          </div>
        </form>
      </Fragment>
      {isAddressSelected ? (
        <Fragment>
          <form className='form-default'>
            <div className='row'>
              <div className='col-sm-12 col-md-6 col-lg-6'>
                <div className='form-group'>
                  <label htmlFor='input_nombre'>{i18n.t('domicilios.nombre')}</label>

                  <input
                    type='text'
                    id='input_nombre'
                    name='nombre'
                    maxLength={50}
                    value={
                      isCustomAddress && pedido.nombre_dom_envio === ''
                        ? ''
                        : pedido.nombre_dom_envio || domicilio.nombre || ''
                    }
                    className='form-control'
                    placeholder='Nombre'
                    onChange={e => {
                      dispatch(setNombreDomEnvioMod(e.target.value))
                    }}
                    onFocus={handleFocus}
                    readOnly={!editableFields}
                    disabled={pedido_cargando || props.pedidoGuardado || !editableFields}
                  />
                </div>
              </div>
              <div className='col-sm-12 col-md-6 col-lg-6'>
                <div className='form-group'>
                  <label htmlFor='input_direccion'>{i18n.t('domicilios.direc')}</label>
                  <input
                    type='text'
                    id='input_direccion'
                    maxLength={500}
                    name='direccion'
                    value={
                      isCustomAddress && pedido.direccion_dom_envio === ''
                        ? ''
                        : pedido.direccion_dom_envio || domicilio.direccion || ''
                    }
                    className='form-control'
                    placeholder='Dirección'
                    onChange={e => {
                      dispatch(setDireccionDomEnvioMod(e.target.value))
                    }}
                    onFocus={handleFocus}
                    readOnly={!editableFields}
                    disabled={pedido_cargando || props.pedidoGuardado || !editableFields}
                  />
                </div>
              </div>
            </div>
            <div className='row'>
              <div className='col-sm-12 col-md-6 col-lg-6'>
                <div className='form-group'>
                  <label htmlFor='input_estado'>
                    {i18n.t('domicilios.estdomay')} <sup>*</sup>
                  </label>

                  {editableFields && false ? (
                    <select
                      className='form-control'
                      name='estado'
                      id='input_estado'
                      onChange={onChange}
                      value={pedido.estado_dom_envio || domicilio.estado || ''}
                      placeholder='Estado'
                      disabled={pedido_cargando || props.pedidoGuardado || true}>
                      <option value=''>{i18n.t('domicilios.estdomin')}</option>
                      {estados?.length > 0
                        ? estados.map((estado, index) => {
                            return (
                              <option
                                key={index}
                                value={estado.codigo}>
                                {estado?.nombre}
                              </option>
                            )
                          })
                        : ''}
                    </select>
                  ) : (
                    <input
                      type='text'
                      id='input_estado'
                      name='estado'
                      value={estado?.nombre || ''}
                      className='form-control'
                      placeholder={i18n.t('domicilios.estdomin')}
                      onChange={onChange}
                      readOnly
                      disabled={pedido_cargando || props.pedidoGuardado || true}
                    />
                  )}
                </div>
              </div>
              <div className='col-sm-12 col-md-6 col-lg-6'>
                <div className='form-group'>
                  <label htmlFor='input_provincia'>
                    {i18n.t('domicilios.prov')} <sup>*</sup>
                  </label>
                  {editableFields && !previousProvinceLocked ? (
                    <select
                      className='form-control'
                      name='provincia'
                      id='input_provincia'
                      onChange={onChange}
                      value={pedido.provincia_dom_envio || domicilio.provincia || ''}
                      placeholder='Provincia'
                      disabled={pedido_cargando || props.pedidoGuardado}>
                      <option value=''>{i18n.t('domicilios.provmin')}</option>
                      {provincias && provincias.length > 0
                        ? provincias.map((provincia, index) => {
                            return (
                              domicilio?.estado !== 'ES' ||
                              (domicilio?.estado === 'ES' &&
                                !provinciasBloqueadas.includes(provincia.provincia) && (
                                  <option
                                    key={index}
                                    value={provincia.provincia}>
                                    {provincia?.nombre}
                                  </option>
                                ))
                            )
                          })
                        : ''}
                    </select>
                  ) : (
                    <input
                      type='text'
                      name='provincia'
                      id='input_provincia'
                      value={provincia?.nombre || ''}
                      className='form-control'
                      placeholder={i18n.t('domicilios.provmin')}
                      onChange={onChange}
                      readOnly={!editableFields && !previousProvinceLocked}
                      disabled={
                        pedido_cargando ||
                        props.pedidoGuardado ||
                        previousProvinceLocked ||
                        !editableFields
                      }
                    />
                  )}
                </div>
              </div>
            </div>
            <div className='row'>
              <div className='col-sm-12 col-md-4 col-lg-4'>
                <div className='form-group'>
                  <label htmlFor='input_localidad'>{i18n.t('domicilios.local')}</label>
                  <input
                    type='text'
                    name='localidad'
                    id='input_localidad'
                    value={
                      isCustomAddress && pedido.localidad_dom_envio === ''
                        ? ''
                        : pedido.localidad_dom_envio || domicilio.localidad || ''
                    }
                    className='form-control'
                    maxLength={50}
                    placeholder={i18n.t('domicilios.localmin')}
                    onChange={e => {
                      dispatch(setLocalidadDomEnvioMod(e.target.value))
                    }}
                    onFocus={handleFocus}
                    readOnly={!editableFields}
                    disabled={pedido_cargando || props.pedidoGuardado || !editableFields}
                  />
                </div>
              </div>
              <div className='col-sm-12 col-md-4 col-lg-4'>
                <div className='form-group'>
                  <label htmlFor='input_cod_postal'>{i18n.t('domicilios.codpstal')}</label>
                  <input
                    type='text'
                    id='input_cod_postal'
                    name='cod_postal'
                    value={
                      isCustomAddress && pedido.cod_postal_dom_envio === ''
                        ? ''
                        : pedido.cod_postal_dom_envio || domicilio.cod_postal || ''
                    }
                    className='form-control'
                    placeholder={i18n.t('domicilios.codposmi')}
                    maxLength={15}
                    onChange={e => {
                      dispatch(setCodPostalDomEnvioMod(e.target.value))
                    }}
                    onFocus={handleFocus}
                    readOnly={!editableFields}
                    disabled={pedido_cargando || props.pedidoGuardado || !editableFields}
                  />
                </div>
              </div>
              {/**
            <div className='col-sm-12 col-md-4 col-lg-4'>
                      <div className='form-group tipo-portes-group'>
                <label htmlFor='input_tipo_portes'>{i18n.t('domicilios.tipport')}</label>
                <input
                  type='checkbox'
                  id='input_tipo_portes'
                  name='tipo_portes'
                  className='form-control'
                  value={Boolean(pedido?.tipo_portes_dom_envio === 'S')}
                  placeholder={i18n.t('domicilios.tippormi')}
                  onChange={e => {
                    if (e.target.checked) {
                      dispatch(setTipoPortesDomEnvioMod('S'))
                    } else {
                      dispatch(setTipoPortesDomEnvioMod('N'))
                    }
                  }}
                  readOnly={!props.editable}
                  disabled={pedido_cargando || props.pedidoGuardado}
                  checked={pedido?.tipo_portes_dom_envio === 'S'}
                />

              </div>
            </div>
            **/}
            </div>
          </form>
        </Fragment>
      ) : (
        <></>
      )}
    </div>
  )
}

export default DomiciliosEnvio
